<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="800px">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="120px">
      <el-form-item label="公告内容" prop="content">
        <el-input v-model="dataForm.content" placeholder="请输入公告内容" maxlength="200" show-word-limit></el-input>
      </el-form-item>
      
      <el-form-item label="链接类型" prop="linkType">
        <el-radio-group v-model="dataForm.linkType">
          <el-radio label="inner">内部页面</el-radio>
          <el-radio label="outer">外部链接</el-radio>
        </el-radio-group>
      </el-form-item>
      
      <el-form-item label="跳转链接" prop="linkUrl">
        <el-input v-model="dataForm.linkUrl" placeholder="例如：/pages/article/list 或 https://www.example.com"></el-input>
        <div style="color: #999; font-size: 12px; margin-top: 5px;">
          内部页面示例：/pages/article/list<br>
          外部链接示例：https://www.example.com
        </div>
      </el-form-item>
      
      <el-form-item label="图标" prop="icon">
        <el-input v-model="dataForm.icon" placeholder="请输入Emoji图标" maxlength="10">
          <template slot="append">
            <el-button @click="showIconPicker = !showIconPicker">选择图标</el-button>
          </template>
        </el-input>
        <div v-if="showIconPicker" style="margin-top: 10px; padding: 10px; border: 1px solid #ddd; border-radius: 4px;">
          <span v-for="emoji in emojiList" :key="emoji" 
                @click="selectEmoji(emoji)" 
                style="font-size: 24px; margin: 5px; cursor: pointer; display: inline-block;">
            {{ emoji }}
          </span>
        </div>
      </el-form-item>
      
      <el-form-item label="背景颜色" prop="bgColor">
        <el-input v-model="dataForm.bgColor" placeholder="CSS背景样式">
          <template slot="prepend">预览</template>
          <template slot="append">
            <div :style="{background: dataForm.bgColor, width: '60px', height: '30px'}"></div>
          </template>
        </el-input>
        <div style="color: #999; font-size: 12px; margin-top: 5px;">
          示例：linear-gradient(90deg, #FC6103 0%, #FFB56E 100%)<br>
          或纯色：#FF6B6B
        </div>
      </el-form-item>
      
      <el-form-item label="文字颜色" prop="textColor">
        <el-color-picker v-model="dataForm.textColor"></el-color-picker>
        <span style="margin-left: 10px;">{{ dataForm.textColor }}</span>
      </el-form-item>
      
      <el-form-item label="是否启用" prop="isEnable">
        <el-switch
          v-model="dataForm.isEnable"
          :active-value="1"
          :inactive-value="0"
          active-text="启用"
          inactive-text="禁用">
        </el-switch>
        <div style="color: #ff9800; font-size: 12px; margin-top: 5px;">
          注意：只有启用状态且排序最小的公告会显示在前端
        </div>
      </el-form-item>
      
      <el-form-item label="排序" prop="sortOrder">
        <el-input-number v-model="dataForm.sortOrder" :min="0" :max="9999"></el-input-number>
        <span style="margin-left: 10px; color: #999;">数字越小越靠前</span>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      showIconPicker: false,
      emojiList: ['🔊', '📢', '📣', '📯', '🔔', '🎉', '🎊', '✨', '⭐', '🌟', '💫', '🔥', '👋', '📌', '🎯', '💡', '⚡', '🚀', '🎁', '🏆'],
      dataForm: {
        id: 0,
        content: '',
        linkUrl: '',
        linkType: 'inner',
        icon: '🔊',
        bgColor: 'linear-gradient(90deg, #FC6103 0%, #FFB56E 100%)',
        textColor: '#FFFFFF',
        isEnable: 1,
        sortOrder: 0
      },
      dataRule: {
        content: [
          { required: true, message: '公告内容不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: `/noticeBar/info/${this.dataForm.id}`,
            method: 'get'
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.dataForm.content = data.data.content
              this.dataForm.linkUrl = data.data.linkUrl
              this.dataForm.linkType = data.data.linkType
              this.dataForm.icon = data.data.icon
              this.dataForm.bgColor = data.data.bgColor
              this.dataForm.textColor = data.data.textColor
              this.dataForm.isEnable = data.data.isEnable
              this.dataForm.sortOrder = data.data.sortOrder
            }
          })
        }
      })
    },
    selectEmoji(emoji) {
      this.dataForm.icon = emoji
      this.showIconPicker = false
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: `/noticeBar/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            data: this.dataForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>

